import React, { FunctionComponent } from "react";
import { _DefinitionList } from "./_DefinitionList";

const DefinitionList: FunctionComponent = ({ children }) => (
  <_DefinitionList>{children}</_DefinitionList>
);

export default DefinitionList;
